
export enum INSPECTION_TYPE {
  PICKUP = 'pickup',
  DELIVERY = 'delivery',
}